import SecurityPreferencesComponent from './SecurityPreferencesComponent';

export  default SecurityPreferencesComponent;